import request from './../utils/request'

export function getBrandOptions(params) {
  return request({
    url: 'api/brand/getOptions',
    method: 'get',
    params
  })
}
